var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExplore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "explore_svg__explore_svg__Canvas",
    transform: "translate(17321 6553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "explore_svg__explore_svg__Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "explore_svg__explore_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "explore_svg__explore_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#explore_svg__explore_svg__path0_fill",
    transform: "translate(-17316.8 -6549.23)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "explore_svg__explore_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#explore_svg__explore_svg__path1_fill",
    transform: "translate(-17316.1 -6553)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "explore_svg__explore_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#explore_svg__explore_svg__path2_fill",
    transform: "translate(-17311.5 -6548.13)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "explore_svg__explore_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#explore_svg__explore_svg__path3_fill",
    transform: "translate(-17316.1 -6543.61)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "explore_svg__explore_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#explore_svg__explore_svg__path4_fill",
    transform: "translate(-17321 -6548.13)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "explore_svg__explore_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#explore_svg__explore_svg__path5_fill",
    transform: "matrix(0.710253 0.703933 -0.709456 0.704736 -17312.2 -6551.76)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "explore_svg__explore_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#explore_svg__explore_svg__path6_fill",
    transform: "matrix(-0.709854 -0.704335 0.709854 -0.704335 -17319.1 -6543.59)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "explore_svg__explore_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#explore_svg__explore_svg__path7_fill",
    transform: "matrix(-0.709854 -0.704335 0.709854 -0.704335 -17318.8 -6550.23)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "explore_svg__explore_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#explore_svg__explore_svg__path8_fill",
    transform: "matrix(0.926233 0.37687 -0.381941 0.924154 -17314 -6552.77)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "explore_svg__explore_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#explore_svg__explore_svg__path9_fill",
    transform: "matrix(-0.926233 -0.37687 0.381941 -0.924154 -17317.2 -6542.57)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "explore_svg__explore_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#explore_svg__explore_svg__path10_fill",
    transform: "matrix(0.926332 0.376671 -0.38174 0.924255 -17320.4 -6550.11)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "explore_svg__explore_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#explore_svg__explore_svg__path11_fill",
    transform: "matrix(-0.923467 0.383541 -0.38867 -0.92132 -17310.5 -6549.31)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "explore_svg__explore_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#explore_svg__explore_svg__path12_fill",
    transform: "matrix(0.924003 -0.382429 0.389191 0.921175 -17320.8 -6546.04)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "explore_svg__explore_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#explore_svg__explore_svg__path13_fill",
    transform: "matrix(0.388268 0.921522 -0.923665 0.383143 -17317.3 -6552.76)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "explore_svg__explore_svg__path0_fill",
    d: "M 6.21577 3.36537L 6.30019 3.16141L 5.12115 2.68238L 5.0908 2.75652L -2.17927e-07 2.20094e-07L 5.46673 17.817L 8.36879 10.1963L 16.4767 8.92118L 6.21577 3.36537Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "explore_svg__explore_svg__path1_fill",
    d: "M 0.909208 0L 0 0L 0 1.2635L 0.909208 1.2635L 0.909208 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "explore_svg__explore_svg__path2_fill",
    d: "M 1.2734 0L 0 0L 0 0.902898L 1.2734 0.902898L 1.2734 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "explore_svg__explore_svg__path3_fill",
    d: "M 0.909208 0L 0 0L 0 1.26325L 0.909208 1.26325L 0.909208 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "explore_svg__explore_svg__path4_fill",
    d: "M 1.27391 0L 0 0L 0 0.902898L 1.27391 0.902898L 1.27391 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "explore_svg__explore_svg__path5_fill",
    d: "M 0.906192 0L 0 0L 0 1.26896L 0.906192 1.26896L 0.906192 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "explore_svg__explore_svg__path6_fill",
    d: "M 0.906697 0L 0 0L 0 1.26846L 0.906697 1.26846L 0.906697 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "explore_svg__explore_svg__path7_fill",
    d: "M 1.26871 0L 0 0L 0 0.906442L 1.26871 0.906442L 1.26871 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "explore_svg__explore_svg__path8_fill",
    d: "M 0.908193 0L 0 0L 0 1.26518L 0.908193 1.26518L 0.908193 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "explore_svg__explore_svg__path9_fill",
    d: "M 0.908958 0L 0 0L 0 1.26518L 0.908958 1.26518L 0.908958 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "explore_svg__explore_svg__path10_fill",
    d: "M 1.27224 0L 0 0L 0 0.903919L 1.27224 0.903919L 1.27224 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "explore_svg__explore_svg__path11_fill",
    d: "M 1.27244 0L 0 0L 0 0.903703L 1.27244 0.903703L 1.27244 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "explore_svg__explore_svg__path12_fill",
    d: "M 1.27168 0L 0 0L 0 0.904207L 1.27168 0.904207L 1.27168 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "explore_svg__explore_svg__path13_fill",
    d: "M 1.26548 0L 0 0L 0 0.908924L 1.26548 0.908924L 1.26548 0Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplore);
export default __webpack_public_path__ + "static/media/explore.80ee8fc12c3ae631203f816ad6ad1997.svg";
export { ForwardRef as ReactComponent };